module.exports = __webpack_public_path__ + "static/img/wx04.ad1f1b0c.png";